import { HeroSection, PricingPlan, VoIPSteps, VoIPFeatures, VoIPKeyBenefits, VoipVideo } from "@/components/features/3CX";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function Voip() {
  return (
    <div>
      <SEO
          title="VoIP service Service Business VoIP service Solutions - SAN micron"
          description="Boost your business communications with VoIP’s VoIP service solutions. Enjoy seamless calls, video conferencing, and collaboration tools designed to enhance productivity and connectivity."
      />
      {/* <Breadcrumbs /> */}
      <HeroSection />
      <VoIPKeyBenefits />
      <VoIPSteps />
      <PricingPlan />
      <VoipVideo />
      <VoIPFeatures />
      {/* <CallToAction /> */}
      <Footer />
    </div>
  )
}